import * as fromComment from '../comment.model';
import { Contact } from '../contact.model';
import { RecordType } from '../record-type.model';
import { SalesforceBase } from '../salesforce-base.model';
import { Service } from '../service.model';

export enum TicketGrouping {
  Type,
  Status,
  Location,
  None,
}
export enum TicketGroupingLabel {
  Type = 'Type',
  Status = 'Status',
  Location = 'Location',
  None = 'None',
}

export enum TicketType {
  Care,
  Proactive,
  Maintenance,
  Support,
  Finance,
  NonProactive,
  Emergency,
  Other, // fallback for unknown types
}

export enum TicketRecordType {
  Care = 'Care',
  Proactive = 'Proactive',
  Maintenance = 'Maintenance',
  Support = 'Support',
  NOC = 'NOC',
  Finance = 'Finance',
  NonProactive = 'NonProactive',
  Emergency = 'Emergency',
  Other = 'Other', // fallback for unknown types
}

export enum BusinessPurpose {
  // NetEng
  NetEngMaintenanceEmergency = 'NetEng - Emergency Maintenance',
  NetEngMaintenanceStandard = 'NetEng - Standard Maintenance',

  // NOC
  NocBandwidthThroughput = 'NOC - Bandwidth/Throughput',
  NocCircuitErrorsBouncing = 'NOC - Circuit Errors/Bouncing',
  NocCpeHardwareIssue = 'NOC - CPE/Hardware issue',
  NocLatencyPacketLoss = 'NOC - Latency/Packet Loss',
  NocBandwidth = 'NOC - Bandwidth / Throughput',
  NocChronic = 'NOC - Chronic',
  NocCircuitDown = 'NOC - Circuit Down',
  NocCircuitDownDisconnected = 'NOC - Circuit Down / Disconnected',
  NocCircuitDownBroadband = 'NOC - Circuit Down - Broadband',
  NocCircuitErrors = 'NOC - Circuit Errors / Bouncing',
  NocCircuitUpNoSurf = 'NOC - Circuit Up / No Surf',
  NocCosApplications = 'NOC - COS / Applications',
  NocCpeIssue = 'NOC - CPE / Hardware issue',
  NocCustomerFacilitiesIssue = 'NOC - Customer Facilities issue',
  NocFirewallIssue = 'NOC - Firewall Issue',
  NocLatency = 'NOC - Latency / Packet Loss',
  NocNetworkOutage = 'NOC - Network Outage',
  NocRoutingIssue = 'NOC - Routing issue',
  NocSdwanIssue = 'NOC - SDWAN Issue',
  NocTechQuestion = 'NOC - Technical Question',
  NocVoipCosMpls = 'NOC - VOIP / CoS MPLS',
  NOCProactiveNotification = 'NOC - Nitel Proactive Notification',
  NOCProactiveCarrierAlert = 'NOC - Proactive Alert/Carrier',
  NOCProactiveAlert = 'NOC - Proactive Alert/Nitel',
  NOCProactiveCustomerAlert = 'NOC - Proactive Alert/Customer',
  NOCProactiveVersaAlert = 'NOC - Proactive Versa Alert',
  NOCMaintenanceScheduled = 'NOC - Scheduled Maintenance',
  NOCMaintenanceEmergency = 'NOC - Emergency Maintenance',
  NOCSupport = 'NOC - Support',

  // SD-WAN
  SdWanAddIps = 'SD - WAN Add IPs',
  SdWanConfigChange = 'SD - WAN Config Change',
  SdWanGeneral = 'SD - WAN General',
  SupportConfigChange = 'Support - Config Change',
  SupportConfigRequest = 'Support - Config Request',
  SupportDnsChange = 'Support - DNS Change',
  SupportFirewallChange = 'Support - Firewall Config Change',
  SupportIpRequest = 'Support - IP Request',
  SupportSdwanConfigChange = 'Support - SDWAN Config Change',
  SupportUtilizationRequest = 'Support - Utilization Request',

  // MSC
  MscBandwidthThroughput = 'MSC - Bandwidth/Throughput',
  MscConfigurationChange = 'MSC - Configuration Change',
  MscCpeHardwareIssue = 'MSC - CPE/Hardware Issue',
  MscCustomerFacilitiesIssue = 'MSC - Customer Facilities Issue',
  MscCustomerRfoRequest = 'MSC - Customer RFO Request',
  MscFirewallIssue = 'MSC - Firewall Issue',
  MscLatencyPacketLoss = 'MSC - Latency/Packet Loss',
  MscNetworkOutage = 'MSC - Network Outage',
  MscSdwanIssue = 'MSC - SDWAN Issue',
  MscServiceReview = 'MSC - Service Review',
  MscTechnicalQuestion = 'MSC - Technical Question',
  MscUtilizationRequest = 'MSC - Utilization Request',
  MscVoipIssue = 'MSC - VOIP Issue',

  // SD-WAN
  SdwanAddIps = 'SD-WAN Add IPs',
  SdwanConfigChange = 'SD-WAN Config Change',
  SdwanGeneral = 'SD-WAN General',

  // Other
  CareOther = 'Care - Other',
}
export enum TicketStatus {
  Open = 'Open',
  Closed = 'Closed',
  New = 'New',
  Pending = 'Pending',
}

export interface Ticket extends SalesforceBase {
  Time_to_Repair_Days__c: number;
  First_touch__c: Date;
  Business_Purpose__c?: string;
  CaseNumber?: string;
  ClosedDate?: Date;
  Comments__r?: fromComment.Record;
  Contact?: Contact;
  Customer_Ticket_Number__c?: string;
  CreatedDate: Date;
  Description?: string;
  IsClosed?: boolean;
  Maintenance_Date__c?: Date;
  Portal_Ticket_Type__c?: string;
  Service_Location_Address__c?: string;
  Service__c?: string;
  Service__r?: Service;
  Status?: TicketStatus;
  Subject?: string;
  RecordType?: RecordType;
  AccountId?: string;
  Close_Code__c?: string;
}

export interface CSVTicket {
  'Ticket Number': string;
  'Business Purpose': string;
  Title: string;
  Status: string | TicketStatus;
  Location: string;
  Service?: string;
  'Maintenance Date'?: string | Date;
}

export interface GroupedTickets<K> {
  key: K;
  items: Ticket[];
}

export type TicketAggregate = {
  closed: number;
  finance: number;
  nonProactive: number;
  open: number;
  proactive: number;
  support: number;
  total: number;
};
